import React from 'react'
import useSWR from 'swr'
import { useLoggedUser } from '../../utils/local_storage_user'
import { fetchPrescriptions } from './PrescriptionService'
import PrescriptionView from './PrescriptionView'

export default function PrescriptionList({ history }) {
    const user = useLoggedUser({ history })

    const { data: prescriptions = [], isValidating } = useSWR(
        ['prescription/list', user.token],
        () => fetchPrescriptions(user.token),
        {
            revalidateOnFocus: false,
        }
    )

    return (
        <PrescriptionView
            prescriptions={prescriptions}
            loading={isValidating}
        />
    )
}
